import { Component, OnInit, Input } from '@angular/core';
import { GetAccountsResponse, AccountFlowStatistics } from '../../store';
import { DoughnutChartData } from '../doughnut-chart/doughnut-chart.component';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
interface Account {
  accountId: string;
  active: number;
  draft: number;
  paused: number;
}
@Component({
  selector: 'ma-account-stats',
  templateUrl: './account-stats.component.html',
  styleUrls: ['./account-stats.component.scss'],
})
export class AccountStatsComponent implements OnInit {
  draft: DoughnutChartData[] = [];
  paused: DoughnutChartData[] = [];
  active: DoughnutChartData[] = [];
  activeTotal: number;
  pausedTotal: number;
  draftTotal: number;

  accountsList: {
    accountId: string;
    active: number;
    draft: number;
    paused: number;
  }[] = [];

  accounts$ = new BehaviorSubject<Account[]>([]);
  @Input() set accounts(accounts: GetAccountsResponse) {
    const { draft, paused, active } = Object.entries(accounts).reduce(
      (acc, [accountId, values]) => {
        Object.entries(values).forEach(([type, value]) => {
          acc[type].push({ label: accountId, value });
        });
        return acc;
      },
      { draft: [], paused: [], active: [] },
    );
    this.accounts$.next(
      Object.entries(accounts).map(([accountId, values]) => ({
        accountId,
        active: +values.active || 0,
        draft: +values.draft || 0,
        paused: +values.paused || 0,
      })),
    );
    this.draft = draft;
    this.draftTotal = draft.reduce((acc, item) => acc + item.value, 0);
    this.paused = paused;
    this.pausedTotal = paused.reduce((acc, item) => acc + item.value, 0);
    this.active = active;
    this.activeTotal = active.reduce((acc, item) => acc + item.value, 0);
  }

  excludeAccountId$ = new BehaviorSubject<string>(null);
  includeAccountId$ = new BehaviorSubject<string>(null);
  filteredAccounts$ = combineLatest([
    this.accounts$,
    this.excludeAccountId$,
    this.includeAccountId$,
  ]).pipe(
    map(([accounts, excludeAccountId, includeAccountId]) => ({
      excludeAccountId,
      includeAccountId,
      accounts: !!(excludeAccountId || '').trim()
        ? accounts.filter(
            (account) => !account.accountId.includes(excludeAccountId.trim()),
          )
        : accounts,
    })),
    map(({ accounts, includeAccountId }) =>
      !!(includeAccountId || '').trim()
        ? accounts.filter((account) =>
            account.accountId.includes(includeAccountId.trim()),
          )
        : accounts,
    ),
    map((accounts) =>
      accounts
        .slice()
        .sort((a, b) =>
          a.accountId < b.accountId ? -1 : a.accountId > b.accountId ? 1 : 0,
        ),
    ),
  );

  onSearch(text: string) {}

  constructor() {}

  ngOnInit() {}
}
